export enum WarehouseReleaseStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
}
